module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ga-Hc-Ib-Jb.83534c0f.png";